import { render, staticRenderFns } from "./addItemReleaseViewList.vue?vue&type=template&id=7afb73e3&scoped=true"
import script from "./addItemReleaseViewList.vue?vue&type=script&lang=js"
export * from "./addItemReleaseViewList.vue?vue&type=script&lang=js"
import style0 from "./addItemReleaseViewList.vue?vue&type=style&index=0&id=7afb73e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb73e3",
  null
  
)

export default component.exports